// @ts-nocheck
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import OrderHeader from "@store/Library/Components/Toolkit/Order/OrderHeader";
import constants from "@store/constants";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React, { FC } from "react";
import { useSelector } from "react-redux";

export interface RecommendedProductRequestHeaderProps extends WidgetProps {}

export interface RecommendedProductRequestHeaderStyles {}

export const recommendedProductRequestHeaderStyles: RecommendedProductRequestHeaderStyles = {};

const styles = recommendedProductRequestHeaderStyles;

type Props = RecommendedProductRequestHeaderProps;

const RecommendedProductRequestHeader: FC<Props> = ({ id }) => {
    const queryParams = parseQueryString<{ returnPage?: string }>(
        useSelector((state: ApplicationState) => getLocation(state).search),
    );

    const currentPage = useCurrentPage();
    const linkBack = queryParams.returnPage
        ? usePageLinkByPageType(queryParams.returnPage)
        : usePageLinkByPageType(constants.pageType.productDetails);

    return (
        <OrderHeader title={currentPage.fields.title} linkBack={linkBack}>
            <Zone contentId={id} zoneName="ActionButtons" />
        </OrderHeader>
    );
};

const widgetModule: WidgetModule = {
    component: RecommendedProductRequestHeader,
    definition: {
        displayName: "Header",
        group: constants.widgetGroup.recommendedProductRequest,
        allowedContexts: [constants.pageType.recommendedProductRequest],
    },
};

export default widgetModule;
